// ===== AGRICULTURE, LIFE & BIO SCIENCES =====
const AGRI_BIO = [
  {
    id: "bsc-agriculture",
    name: "B.Sc Agriculture",
    stream: "science",
    category: "agri-bio",
    summary:
      "Crop production, horticulture, soil science, plant breeding, agribusiness, and farm management.",
    eligibility: "10+2 with PCB/PCM; entrance via ICAR AIEEA, CUET UG, or state agriculture entrance exams.",
    exams: ["ICAR AIEEA", "State Agriculture CETs", "CUET UG"],
    colleges: [
      "Tamil Nadu Agricultural University (TNAU) Coimbatore",
      "Punjab Agricultural University (PAU) Ludhiana",
      "CCS Haryana Agricultural University Hisar",
      "University of Agricultural Sciences Bengaluru",
      "Banaras Hindu University – Institute of Agricultural Sciences"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["horticulture", "soil science", "crop production", "agri-business"],
  },
  {
    id: "bsc-biotechnology",
    name: "B.Sc Biotechnology",
    stream: "science",
    category: "agri-bio",
    summary:
      "Genetics, molecular biology, microbiology, bioinformatics, healthcare, and industrial biotechnology.",
    eligibility:
      "10+2 with PCB/PCM; entrance via CUET UG, state-level CETs, or university-specific exams.",
    exams: ["CUET UG", "State CETs", "JNU Entrance", "Jamia Millia Islamia Entrance"],
    colleges: [
      "Jawaharlal Nehru University (JNU) New Delhi",
      "University of Delhi (DU) – Miranda House, St. Stephens College",
      "Amity University",
      "VIT Vellore",
      "Alagappa University, Karaikudi"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["genetics", "molecular biology", "bioinformatics", "biotech"],
  },
  {
    id: "bsc-veterinary",
    name: "B.V.Sc & AH (Veterinary Science)",
    stream: "science",
    category: "agri-bio",
    summary:
      "Animal health, surgery, pathology, husbandry, livestock management, and veterinary research.",
    eligibility: "10+2 with PCB; entrance via NEET-UG (some states), VCI exam, or state-level exams.",
    exams: ["NEET-UG", "VCI Entrance", "State Veterinary CETs"],
    colleges: [
      "Indian Veterinary Research Institute (IVRI), Bareilly",
      "CCS Haryana Agricultural University Hisar",
      " Bombay Veterinary College, Mumbai",
      "Tamil Nadu Veterinary and Animal Sciences University (TANUVAS) Chennai",
      "Veterinary Colleges in Punjab, Haryana, Karnataka"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["animal health", "clinical", "husbandry", "veterinary"],
  },
  {
    id: "bsc-food-tech",
    name: "B.Tech / B.Sc Food Technology",
    stream: "science",
    category: "agri-bio",
    summary:
      "Food processing, preservation, nutrition, quality control, product development, and food safety.",
    eligibility: "10+2 with PCB/PCM; entrance via JEE Main (B.Tech) or CUET UG/B.Sc programs.",
    exams: ["JEE Main (B.Tech)", "CUET UG", "State University CETs"],
    colleges: [
      "IIT Kharagpur – Food Technology",
      "NIFTEM (National Institute of Food Technology, Haryana)",
      "Punjab Agricultural University, Ludhiana",
      "Amity University, Noida",
      "Bangalore University – Food Science Dept."
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["food processing", "nutrition", "quality control", "food science"],
  },
  {
    id: "bsc-horticulture",
    name: "B.Sc Horticulture",
    stream: "science",
    category: "agri-bio",
    summary:
      "Study of fruits, vegetables, flowers, landscaping, plant breeding, and sustainable cultivation techniques.",
    eligibility: "10+2 with PCB/PCM; entrance via ICAR AIEEA, state-level CETs, or CUET UG.",
    exams: ["ICAR AIEEA", "State CETs", "CUET UG"],
    colleges: [
      "Punjab Agricultural University (PAU) Ludhiana",
      "Tamil Nadu Agricultural University (TNAU) Coimbatore",
      "GB Pant University of Agriculture & Technology",
      "Banaras Hindu University – Horticulture",
      "UAS Bengaluru"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["fruits", "vegetables", "plant breeding", "landscaping"],
  },
  {
    id: "bsc-fisheries",
    name: "B.F.Sc (Fisheries Science)",
    stream: "science",
    category: "agri-bio",
    summary:
      "Aquaculture, fish breeding, marine resource management, fish processing, and aquatic ecology.",
    eligibility: "10+2 with PCB; entrance via ICAR AIEEA, CUET UG, or state-level fisheries exams.",
    exams: ["ICAR AIEEA", "State Fisheries CETs", "CUET UG"],
    colleges: [
      "CIFE Mumbai",
      "Tamil Nadu Fisheries University, Chennai",
      "Gujarat Agricultural University",
      "Kerala University of Fisheries & Ocean Studies",
      "GB Pant University of Agriculture & Technology"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["aquaculture", "fish breeding", "marine biology", "fisheries"],
  },
  {
    id: "bsc-forestry",
    name: "B.Sc Forestry / Environmental & Forest Sciences",
    stream: "science",
    category: "agri-bio",
    summary:
      "Forest management, conservation, ecology, biodiversity, soil and water management.",
    eligibility: "10+2 with PCB/PCM; entrance via ICAR AIEEA or state forestry CETs.",
    exams: ["ICAR AIEEA", "State Forestry CETs", "CUET UG"],
    colleges: [
      "Forest Research Institute, Dehradun",
      "Tamil Nadu Agricultural University, Coimbatore",
      "G.B. Pant University of Agriculture & Technology",
      "Kerala Agricultural University – Forestry",
      "Punjab Agricultural University, Ludhiana"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["forestry", "conservation", "ecology", "biodiversity"],
  },
];

export default AGRI_BIO;
